module.exports = __webpack_public_path__ + "img/7.b15d7882.jpg";